import { useStyles } from "./styles";
import { LeftHeader } from "./Left/old";
import { RightHeader } from "./Right/old";

type HeaderProps = {
  children: React.ReactNode;
};

export function Header({ children }: HeaderProps) {
  const styles = useStyles();
  return (
    <>
      <div id="header-block" className={styles.root}>
        <LeftHeader />
        <RightHeader />
      </div>
      {children}
    </>
  );
}
